export default __webpack_public_path__ + "static/breadcrumbs-size-do-dark-455e1e47797abb6f38373253cd109da9.png";